import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Fa from 'react-fontawesome';
import masterField from '../../../../components/search-form/master-field';

class AccountOwner extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
    this.handleEnableClick = this.handleEnableClick.bind(this);
    this.handleDisableClick = this.handleDisableClick.bind(this);
  }

  handleEnableClick() {
    const { disabled } = this.props;
    if (!disabled) {
      this.props.onChange(true);
    }
  }
  
  handleDisableClick() {
    const { disabled } = this.props;
    if (!disabled) {
      this.props.onChange(false);
    }
  }

  renderStatic() {
    const { value, disabled } = this.props;
    const stl = { cursor: disabled ? 'not-allowed' : 'pointer' };

    const icon = (<span><Fa className={!value ? 'text-active' : ''} name={!value ? 'check-circle' : 'circle-o'} />{' '}</span>);

    return (
      <div>
        <span style={stl} onClick={this.handleDisableClick}>
          {icon}
          <span className={!value ? '' : 'text-muted'}>The opportunity/deal Owner is also the account/company owner.</span>
        </span>
      </div>
    );
  }

  render() {
    const { disabled, value } = this.props;

    const stl = { cursor: disabled ? 'not-allowed' : 'pointer' };
    return (
      <div>
        {this.renderStatic(disabled)}
        <div style={{ height: '10px' }} />
        <div>
          <span style={stl} onClick={this.handleEnableClick}>
            <Fa className={value ? 'text-active' : ''} name={value ? 'check-circle' : 'circle-o'} />
            {' '}
            <span className={value ? '' : 'text-muted'}>The opportunity/deal owner can be different from the account/company owner</span>
          </span>
        </div>
      </div>
    );
  }
}

AccountOwner.propTypes = {
  value: PropTypes.bool.isRequired,
  disabled: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  editable: PropTypes.bool,
};
AccountOwner.defaultProps = {
  disabled: false,
  editable: true,
  onChange: () => {},
};
export default masterField(AccountOwner);
